import { useCallback } from 'react';
import api from '@/lib/api';
import usePaymentMethodsLogic from '@/shared/checkout/usePaymentMethodsLogic';

/**
 * Wrapper CRM do `usePaymentMethodsLogic` partilhado — injecta os endpoints
 * `/api/encomendas/paymentMethods`, `/transportMethods`, `/phoneNumbers` +
 * `/addPhoneNumber`.
 */
export default function usePaymentMethods() {
  const fetchPaymentMethods = useCallback(async () => {
    const { data } = await api.get('/encomendas/paymentMethods');
    return data?.data || [];
  }, []);

  const fetchTransportMethods = useCallback(async () => {
    const { data } = await api.get('/encomendas/transportMethods');
    return data?.data || [];
  }, []);

  const fetchPhoneNumbers = useCallback(async () => {
    const { data } = await api.get('/encomendas/phoneNumbers');
    return data?.success ? (data.data || []) : [];
  }, []);

  const addPhoneNumber = useCallback(async (phone) => {
    const { data } = await api.post('/encomendas/addPhoneNumber', { phone });
    return { ok: !!data?.success, message: data?.message };
  }, []);

  return usePaymentMethodsLogic({
    fetchPaymentMethods, fetchTransportMethods,
    fetchPhoneNumbers, addPhoneNumber,
    methodIdField: 'Id',
  });
}
